import { newItemIsAccessoriesStepForSelfBuy } from '../accessories/accessoriesUtils';
import { getAccessoryPromoData } from '../accessories/accessoriesModule';
import { getPromoRewardsState } from '../promo/promoSelectors';
import { REWARDS_REQUEST_STATE } from '../promo/promoModule';

import messageIntl from './messageIntl';
import { messageStepPreConditions, messageStepPostConditions } from './messageStepSelectors';


const messageStepConfig = {
    component: () => import('./MessageStep'),
    flow: 'buy',
    flowProps: state => ({
        hasAccessories: newItemIsAccessoriesStepForSelfBuy(state),
        promoRewardsState: getPromoRewardsState(state)
    }),
    beforeRender: (dispatch, ownProps) => {
        const { hasAccessories } = ownProps;
        if (hasAccessories) {
            dispatch(getAccessoryPromoData());
        }
    },
    isReady: (state, ownProps) => {
        const { hasAccessories, promoRewardsState } = ownProps;

        const isStillFetching = hasAccessories
            
            
            && promoRewardsState === REWARDS_REQUEST_STATE.ACTIVE;

        return !isStillFetching;
    },
    preConditions: messageStepPreConditions,
    postConditions: messageStepPostConditions,
    getSubmitMessage: ({ hasAccessories, isSelfBuy }) => (
        isSelfBuy && hasAccessories
            ? messageIntl.accessoryHeader
            : messageIntl.submitButtonText),
    canSkip: null 
};

export default messageStepConfig;
